import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDinner = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "lunch",
	"data-name": "lunch",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: .5,
			y1: 14.85,
			x2: 23.5,
			y2: 14.85,
			id: "line26"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 2.4200001,
			y1: 18.690001,
			x2: 21.58,
			y2: 18.690001,
			id: "line28"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.29,
			y1: 22.52,
			x2: 18.709999,
			y2: 22.52,
			id: "line30"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 17.373011,14.942996 a 7.1220856,7.1220856 0 0 0 1.862313,-4.844528 7.2353346,7.2353346 0 0 0 -14.4706692,0 7.1220856,7.1220856 0 0 0 1.8623122,4.819362",
			id: "path32"
		})
	]
});
const ForwardRef = forwardRef(SvgDinner);
export default ForwardRef;
